import { variant } from 'styled-system';

import { deals } from '../../../themes/cobalt/colors/base/product';

const style = {
  deals: {
    fontColor: 'neutral.0',
    gradient: {
      direction: {
        ltr: '135deg',
        rtl: '225deg',
      },
      from: {
        color: deals[30],
        position: '0%',
      },
      to: {
        color: deals[40],
        position: '100%',
      },
    },
  },
};

export default variant({
  prop: 'type',
  variants: {
    deals: {
      background: `linear-gradient(${style.deals.gradient.direction.ltr},${style.deals.gradient.from.color} ${style.deals.gradient.from.position}, ${style.deals.gradient.to.color} ${style.deals.gradient.to.position})`,
      color: style.deals.fontColor,
      '::before': {
        background: style.deals.gradient.from.color,
      },
      'html[dir=rtl] &': {
        background: `linear-gradient(${style.deals.gradient.direction.rtl},${style.deals.gradient.from.color} ${style.deals.gradient.from.position}, ${style.deals.gradient.to.color} ${style.deals.gradient.to.position})`,
      },
    },
  },
});
